var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 2.66665C10.6667 3.40303 8.8758 3.99998 6.66666 3.99998C4.45752 3.99998 2.66666 3.40303 2.66666 2.66665M10.6667 2.66665C10.6667 1.93027 8.8758 1.33331 6.66666 1.33331C4.45752 1.33331 2.66666 1.93027 2.66666 2.66665M10.6667 2.66665V5.33331M2.66666 2.66665V5.33331C2.66666 6.06969 4.45752 6.66665 6.66666 6.66665C8.87579 6.66665 10.6667 6.06969 10.6667 5.33331M13.3333 6.59078C13.3333 7.32716 11.5425 7.92411 9.33332 7.92411C7.12418 7.92411 5.33332 7.32716 5.33332 6.59078V9.25747M13.3333 6.59078C13.3333 6.01024 12.2202 5.51635 10.6667 5.33331M13.3333 6.59078V9.25747C13.3333 9.99385 11.5425 10.5908 9.33332 10.5908C7.12418 10.5908 5.33332 9.99385 5.33332 9.25747M2.66666 10.5149C2.66666 11.2513 4.45752 11.8483 6.66666 11.8483C8.87579 11.8483 10.6667 11.2513 10.6667 10.5149V13.1816C10.6667 13.918 8.87579 14.515 6.66666 14.515C4.45752 14.515 2.66666 13.918 2.66666 13.1816V10.5149ZM2.66666 10.5149C2.66666 9.93439 3.77973 9.44051 5.33332 9.25747",
    stroke: "#000536",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.86bf1d4b5c75a407ee18f9f2000e1a6e.svg";
export { ForwardRef as ReactComponent };